import request from '@/utils/request'

export function getSalesAmountPage(params) {
  return request({
    url: '/api/sales-amount/page',
    method: 'get',
    params
  })
}

export function saveSalesAmount(data) {
  return request({
    url: '/api/sales-amount',
    method: 'post',
    data
  })
}
